export const TopNav: React.FC = ({ children }) => {
    return (
        <div className="d-flex w-100 align-items-center ch-shadow bg border-bottom top-nav-container pl-1 pl-md-3">
            {children}
        </div>
    );
};
